document.addEventListener("DOMContentLoaded", () => {
  const menu = document.querySelector(".menu")!;
  const header = document.querySelector("header")!;
  const navLinks = document.querySelectorAll(".menu a");
  const toTop = document.querySelector("#totop")!;
  const trigger = document.querySelector(".trigger button")!;
  let scrolling = false;
  trigger.addEventListener("click", () => {
    menu.classList.toggle("open");
  })
  navLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      menu.classList.remove("open");
      navLinks.forEach((otherLink) => {
        scrolling = true;
        if (otherLink === link) {
          otherLink.classList.add("active");
        } else {
          otherLink.classList.remove("active");
        }
      });
    });
  })
  const sections = document.querySelectorAll(".section");
  document.addEventListener("scrollend", () => {
    scrolling = false;
  });
  document.addEventListener("scroll", () => {
    if (document.documentElement.scrollTop < 72) {
      toTop?.classList.add("hidden");
      header.classList.remove("sticky");
    } else {
      toTop?.classList.remove("hidden");
      header.classList.add("sticky");
    }
    if (scrolling) {
      return;
    }
    let found = false;
    for (let i = sections.length - 1; i >= 0; i--) {
      const section = sections[i];
      const rect = section.getBoundingClientRect();
      const id = section.getAttribute("id");
      const a = document.querySelector(`a[href="#${id}"]`);
      if (found) {
        a?.classList.remove("active");
      } else {
        if (rect.top < 72) {
          a?.classList.add("active");
          found = true;
        } else if (i > 0) {
          a?.classList.remove("active");
        }
      }
    };
  });
});